import React from 'react';
import Modal from '../shared/Modal';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  entityType: 'member' | 'customer';
  entityName: string;
  reservationCount: number;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  entityType,
  entityName,
  reservationCount,
  onConfirm,
  onCancel,
  loading,
}) => {
  const hasReservations = reservationCount > 0;

  const handlePrivacyRequest = () => {
    alert('Privacy Data Removal Request will be sent to Super Admin. (Coming in Phase 3)');
  };

  const footer = (
    <div className="delete-modal-footer">
      <div className="delete-modal-actions">
        <button className="btn btn-secondary" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
        <button className="btn btn-danger" onClick={onConfirm} disabled={loading}>
          {loading
            ? 'Deleting...'
            : hasReservations
              ? 'Unlink & Delete'
              : 'Delete'}
        </button>
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={`Delete ${entityType === 'member' ? 'Member' : 'Customer'}`}
      size="small"
      footer={footer}
    >
      <div className="delete-confirm-content">
        {hasReservations ? (
          <>
            <div className="delete-warning-banner">
              <strong>Cannot delete directly.</strong>
              <p>
                {entityName} has <strong>{reservationCount}</strong> reservation{reservationCount !== 1 ? 's' : ''}.
              </p>
            </div>
            <p className="delete-explain">
              Choosing "Unlink & Delete" will remove the link between this {entityType} and
              all their reservations, then delete the {entityType}. The reservation records
              will be preserved.
            </p>
          </>
        ) : (
          <p>
            Are you sure you want to delete <strong>{entityName}</strong>? This action cannot be undone.
          </p>
        )}

        <div className="delete-privacy-section">
          <div className="delete-privacy-divider" />
          <button
            className="btn btn-text delete-privacy-btn"
            onClick={handlePrivacyRequest}
            disabled={loading}
          >
            Request Privacy Data Removal
          </button>
          <span className="delete-privacy-hint">
            Sends a request to the Super Admin for full data removal under privacy regulations
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
